import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './ReadTimeRibbon.css';

const ReadTimeRibbon: React.FC = () => {
  const location = useLocation();
  const isShortVersion = location.pathname === '/projects/tmf/short';

  const scrollToFindings = () => {
    const findingsSection = document.getElementById('research-findings');
    if (findingsSection) {
      findingsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="read-time-ribbon">
      <div className="read-time-container">
        <div className="read-time-badge">
          {isShortVersion ? '10 min read' : '35 min read'}
        </div>
        <p className="read-time-message">
          {isShortVersion ? (
            <>
              Want the full story?{' '}
              <Link to="/projects/tmf" className="read-time-link">
                Read complete case study
              </Link>{' '}
              with all details, iterations, and deeper context.
            </>
          ) : (
            <>
              Short on time?{' '}
              <Link to="/projects/tmf/short" className="read-time-link">
                View a shorter version
              </Link>
              {' '}but I'd genuinely appreciate if you could read the full story. There's a lot of heart and intentionality woven into this work.
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default ReadTimeRibbon;
